"use client";

import { useEffect } from "react";
import { useSession } from "next-auth/react";
import * as Sentry from "@sentry/nextjs";

export default function SentryUserIdentifier() {
  const { data: session, status } = useSession();

  useEffect(() => {
    if (status === "authenticated" && session?.user?.id) {
      Sentry.setUser({ id: session.user.id });
    } else if (status === "unauthenticated") {
      Sentry.setUser(null);
    }
  }, [status, session?.user?.id]);

  return null;
}
